import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

import {
  createFocusTrap
} from 'focus-trap';

const SELECTOR_GALLERY_ITEM = '.js-gallery-item';
const SELECTOR_GALLERY_CLOSE = '.js-gallery-close';
const SELECTOR_GALLERY_PREV = '.js-gallery-prev';
const SELECTOR_GALLERY_NEXT = '.js-gallery-next';
const SELECTOR_GALLERY_OVERLAY_IMAGE = '.js-gallery-overlay-image';
const SELECTOR_GALLERY_OVERLAY = '.js-gallery-overlay';
const SELECTOR_GALLERY_CAPTION = '.js-gallery-overlay-caption';

const CLASSNAME_GALLERY_OPEN = 'is-gallery-open';
const CLASSNAME_IS_FADED = 'is-faded';

let isOpen = false;
let items = [];
let current = null;
let trap;

const onGalleryToggle = () => {
  if (isOpen) {
    trap && trap.deactivate();
  } else {
    trap && trap.activate();
  }

  isOpen = !isOpen;
}

const fadeOut = (element) => element.classList.add(CLASSNAME_IS_FADED);

const fadeIn = (element) => element.classList.remove(CLASSNAME_IS_FADED);

const loadImage = (src) => {
  const caption = document.querySelector(SELECTOR_GALLERY_CAPTION);
  const overlayImage = document.querySelector(SELECTOR_GALLERY_OVERLAY_IMAGE);
  const selected = document.querySelector(`[href="${src}"]`);

  fadeOut(overlayImage);

  const tempImg = new Image();
  tempImg.src = src;

  tempImg.onload = () => {
    overlayImage.src = src;
    current = src;
    fadeIn(overlayImage);
    caption.innerHTML = selected.dataset.caption;
  };
}

const onItemClick = (e) => {
  e.preventDefault();
  onGalleryToggle();
  loadImage(e.currentTarget.getAttribute('href'));
}

const onCloseClick = (e) => {
  e.preventDefault();
  onGalleryToggle();
}

const onPrevClick = (e) => {
  e.preventDefault();

  const currentId = items.indexOf(current);
  const prevIndex = currentId - 1 >= 0 ? currentId - 1 : items.length - 1;
  const prevItem = items[prevIndex];
  loadImage(prevItem);
}

const onNextClick = (e) => {
  e.preventDefault();

  const currentId = items.indexOf(current);
  const nextIndex = currentId + 1 <= items.length - 1 ? currentId + 1 : 0;
  const nextItem = items[nextIndex];
  loadImage(nextItem);
}

const init = () => {
  const galleryItems = document.querySelectorAll(SELECTOR_GALLERY_ITEM);
  items = Array.from(galleryItems).map(item => item.getAttribute('href'));

  [].map.call(
    galleryItems,
    item => item.addEventListener('click', onItemClick)
  );

  [].map.call(
    document.querySelectorAll(SELECTOR_GALLERY_CLOSE),
    item => item.addEventListener('click', onCloseClick)
  );

  [].map.call(
    document.querySelectorAll(SELECTOR_GALLERY_PREV),
    item => item.addEventListener('click', onPrevClick)
  );

  [].map.call(
    document.querySelectorAll(SELECTOR_GALLERY_NEXT),
    item => item.addEventListener('click', onNextClick)
  );

  const overlay = document.querySelector(SELECTOR_GALLERY_OVERLAY);

  trap = createFocusTrap(SELECTOR_GALLERY_OVERLAY, {
    onActivate: () => {
      document.body.classList.add(CLASSNAME_GALLERY_OPEN);
      disableBodyScroll(overlay);
    },
    onDeactivate: () => {
      document.body.classList.remove(CLASSNAME_GALLERY_OPEN);
      clearAllBodyScrollLocks();
    },
  });
}

export default {
  init
}
